import { compose, withPropsOnChange, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { omitProps } from '../../../common/helpers/props';
import { withActionByRole } from '../../../common/helpers/actions';
import { getActiveBarberId } from '../selectors';
import { fetchBarberItems, fetchShopItems } from '../../../products/products/actions';

const saleProductsProvider = compose(
  withActionByRole(
    'fetch',
    fetchShopItems,
    fetchBarberItems,
    null,
  ),
  connect(
    state => ({
      activeBarberId: getActiveBarberId(state),
    }),
  ),
  withPropsOnChange(
    ['activeBarberId'],
    props => props.fetch(),
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  }),
  omitProps(['fetch']),
);

export default saleProductsProvider;
